export interface iAlert {
  title?: string;
  msg?: string;
  visible: boolean;
  type?: string;
  class?: string;
}
export interface iModal {
  title?: string;
  msg?: string;
  img?: string;
  visible: boolean;
  type?: string;
}

export class eResponse {
    Sucess: boolean = false;
    Message: string = '';
    Value: eMedia[] = []; 
}
export class eMedia {
    id: string = '';
    dateins: string = '';
    name: string|null = '';
}

export class eLead {
    id: string = '';
    birth: string|null = '';
    name: string|null = '';
    mail: string|null = '';
    phone: string|null = '';
}

export class eClass {
    id: string = '';
    skill: string = '';
    day: string = '';
    time: string = '';
    alive: number = 1;
    _count: number = 0;
}

export class eClick {
    id: string = '';
    dateins: string = '';
    tag: string = '';
    alive: number = 1;
    _count: number = 0;
}

export class ePicture {
  id: string = '';
  dateins: string = '';
  name: string = '';
  alive: number = 1;
  _file_alive: number = 1;
}

export class ePlan {
    id: number = 0;
    name: string = '';
    txt: string = '';
    skill: string = '';
    type: string = '';
    price: string = '';
    alive: number = 0;
    _count: number = 0;
}

export class eFAQ {
    id: number = 0;
    question: string = '';
    answer: string = '';
    alive: number = 0;
    
}

